import { cx } from './cx';

/** Loading placeholder; one status per block so AT hears what is loading. */
export function Skeleton({
  label,
  lines = 3,
  className,
}: {
  label: string;
  lines?: number;
  className?: string;
}) {
  return (
    <div role="status" aria-label={label} className={cx('flex flex-col gap-2', className)}>
      {Array.from({ length: lines }, (_, i) => (
        <span
          key={i}
          aria-hidden="true"
          className="fl-skeleton block h-4"
          style={{ width: `${90 - i * 17}%` }}
        />
      ))}
    </div>
  );
}
